import { render } from "./sorting-algorithms.vue?vue&type=template&id=21fedceb&ts=true"
import script from "./sorting-algorithms.vue?vue&type=script&lang=ts"
export * from "./sorting-algorithms.vue?vue&type=script&lang=ts"

import exportComponent from "/working_dir/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__